import { useNavigate } from 'react-router-dom'
import { Table } from 'reactstrap'
import { enterKeyHandler, setSessionStorage } from '../../../utils'
import useForm from '../../CustomHooks/FormHook'
import '../Custom.css'
import CustomSelectListInput from '../CustomSelectListInput'
import { initialFormValues, stringifyInputs } from '../CustomUtils'
import FormHeading from '../FormHeading'
import FormSubmitButton from '../FormSubmitButton'

export default function ClaimCountsTodayForm({ location }) {
  console.log('ClaimCountsTodayForm rendered: ', location)

  let init = {
    plaintiffStatus: [],
  }

  const navigate = useNavigate()
  init = initialFormValues('ClaimCountsTodayForm', navigate, init)
  const { inputs, handleInputChange, handleSubmit } = useForm(init, submitSearch, enterKeyHandler(submitSearch))

  async function submitSearch() {
    console.log('ClaimCountsTodayForm.submitSearch', inputs)
    inputs.plaintiffStatus = inputs.plaintiffStatus[0] === 'All' ? inputs.plaintiffStatus = [] : inputs.plaintiffStatus
    setSessionStorage('ClaimCountsTodayForm', JSON.stringify(inputs))
    let queryString = `/custom/reports.stat_pit_rep?inputs=${stringifyInputs(inputs)}`
    navigate(queryString)
  }

  return (
    <div className="custom-scroll">
      <form className="form" onSubmit={handleSubmit} style={{ maxWidth: '700px', margin: '20px auto' }}>
        <div>
          <Table bordered className="custom-table custom-form-table" style={{ backgroundColor: 'white' }}>
            <FormHeading headingText="Point in Time Statistical Report" />
            <tbody>
              <CustomSelectListInput label="Plaintiff Status" handleChange={handleInputChange} modelName="Asbestos" entityName="plaintiff_status" name='plaintiffStatus' multiple={true} defaultValue={inputs.plaintiffStatus} />
            </tbody>
          </Table>
        </div>
        <FormSubmitButton />
      </form>
    </div>
  )
}

